import { render, staticRenderFns } from "./CouponSample.vue?vue&type=template&id=5a4d4cea&"
import script from "./CouponSample.vue?vue&type=script&lang=js&"
export * from "./CouponSample.vue?vue&type=script&lang=js&"
import style0 from "./CouponSample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports